module.exports = "<div class=\"userProvisioning\">\n    <div class=\"imgContainer\"></div>\n    <div class=\"content\">\n        The User Provisioning configuration page has been moved to the Users Settings page of the Console.\n        <br>\n        <a class=\"asui-btn btn btn-primary user-provisioning-link\" ng-href=\"{{$ctrl.userProvisioningURL}}\" target=\"_blank\">Go to Console</a>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/settings/components/userProvisioning/userProvisioning.component.html
// module id = 656
// module chunks = 0